import withFormModel from './with-form-model'

export default withFormModel
